'use strict';

if (typeof Promise === 'function') {
  require('promise.prototype.finally/auto'); // eslint-disable-line global-require
}

require('./es2019');
